import { BarChart, BarElementPath } from "@mui/x-charts";
import { useMemo, useRef } from "react";

const BarChartt = ({ data, onBarClick }) => {

  const onBarClickRef = useRef(onBarClick);
  onBarClickRef.current = onBarClick;

  const CustomBar = useMemo(
    () =>
      function CustomBarSlot(props) {
        const { ownerState, ...rest } = props;
        return (
          <BarElementPath
            {...rest}
            ownerState={ownerState}
            onClick={
              onBarClickRef.current
                ? () => onBarClickRef.current(ownerState.dataIndex)
                : undefined
            }
          />
        );
      },
    []
  );

  return (
    <BarChart
      xAxis={[
        {
          id: data?.id,
          data: data?.list,
          scaleType: "band",
          barGapRatio: 0.1,
        },
      ]}
      series={[
        {
          data: data?.values,
        },
      ]}
      height={270}
      slots={onBarClick ? { bar: CustomBar } : undefined}
      sx={
        onBarClick
          ? { "& .MuiBarElement-root": { cursor: "pointer" } }
          : undefined
      }
    />
  );
};

export default BarChartt;
